var custom = {
  init: function () {
    custom.fixedNav();
    custom.sliderHome();
    custom.searchDesk();
    custom.searchExpand();
    custom.countDown();
    custom.countDownNav();
    custom.countDownNavNoti();
    custom.countDownText();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.quantityNum();
    custom.sliderGallery();
    custom.hourReserv();
    custom.socialTeacher();
    custom.icoWhats();
    custom.sliderLearn();
    custom.sliderCommunity();
    custom.textBox();
    custom.sliderCour();
    custom.sliderCourResp();
    custom.sliderCategory();
    custom.titleStiky();
    custom.dropdownHover();
    custom.scrollFilter();
    custom.menuNav();
    custom.toggleFilter();
    custom.countEnabledFilters();
    custom.filterHandle();
    custom.blogNewsletter();
    custom.footerNewsletter();
    custom.partnerRegister();
    custom.sliderEvent();
    custom.activeBtnTab();
    custom.filterFixed();
    custom.addCalendar();
    custom.catFilter();
    custom.categorySlider();
    custom.companyInstitution();
    custom.officialTraining();
    custom.certificatedExpert();
    custom.certSlider();
    custom.certSliderOpc();
    custom.teacherExpert();
    custom.sliderCourse();
    custom.sliderProduct();
    custom.videoIframe();
    custom.fileAdd();
    custom.formContactCustomized();
    custom.payFixed();
    custom.moreBlock();
    custom.moreDesc();
    custom.moreBlockAll();
    custom.moreComment();
    custom.anclaBlockKons();
    custom.videoIframeEvent();
    custom.anclaTop();
    custom.sliderCourseEsp();
    custom.sliderSoftH();
    custom.sliderRoute();
    custom.sliderStudent();
    custom.slideRouteCert();
    custom.scrollBarModal();
    custom.categoryModal();
  },
  menuNav: function () {
    var navContent = document.querySelector(".nav-drill");
    var navExpand = [].slice.call(document.querySelectorAll(".nav-expand"));
    var backLink =
      '<li class="nav-item">\n\t<a class="nav-link nav-back-link" href="javascript:;">\n\t\tAtras\n\t</a>\n</li>';

    navExpand.forEach(function (item) {
      item
        .querySelector(".nav-expand-content")
        .insertAdjacentHTML("afterbegin", backLink);
      item.querySelector(".nav-link").addEventListener("click", function () {
        item.classList.add("active");
        $(this).parents(".nav-drill").addClass("nav-active-hidden");
      });
      item
        .querySelector(".nav-back-link")
        .addEventListener("click", function () {
          item.classList.remove("active");
          $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .removeClass("nav-active-hidden");
        });
    }); // ---------------------------------------
    // not-so-important stuff starts here

    var ham = document.getElementById("ham");
    var close = document.getElementById("navClose");

    ham.addEventListener("click", function () {
      document.body.classList.add("nav-is-toggled");
    });

    close.addEventListener("click", function () {
      document.body.classList.remove("nav-is-toggled");
    });

    $(".nav-drill .btn-login, .nav-drill .btn-register").click(function (e) {
      e.preventDefault();
      document.body.classList.remove("nav-is-toggled");
    });
  },
  anclaTop: function () {
    if ($(".b-ancla-top").length) {
      $(".b-ancla-top a").on("click", function () {
        $("body, html").animate(
          {
            scrollTop: "0px",
          },
          300
        );
      });
    }
  },
  fixedNav: function () {
    if ($(".nav-kons").length) {
      $(".nav-kons").stickit({});
    }
  },
  sliderRoute: function () {
    if ($(".slider-route-one").length) {
      $(".slider-route-one").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  slideRouteCert: function () {
    if ($(".slider-route-three").length) {
      $(".slider-route-three").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  sliderHome: function () {
    if ($(".slider-home").length) {
      $(".slider-home").slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: "linear",
        appendDots: $(".b-arrow-k"),
        prevArrow: $(".prev-s-home"),
        nextArrow: $(".next-s-home"),
      });
      $(".slider-home").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".slider-info").removeClass("aos-init").removeClass("aos-animate");
        }
      );
      $(".slider-home").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          AOS.refresh();
        }
      );
    }
  },
  searchDesk: function () {
    function buttonUp() {
      var inputVal = $(".search-block-desk .searchbox-input").val();
      inputVal = $.trim(inputVal).length;
      if (inputVal !== 0) {
        $(".search-block-desk .searchbox-icon").css("display", "none");
      } else {
        $(".search-block-desk .searchbox-input").val("");
        $(".search-block-desk .searchbox-icon").css("display", "block");
      }
    }
    var submitIcon = $(".search-block-desk .searchbox-icon");
    var inputBox = $(".search-block-desk .searchbox-input");
    var searchBox = $(".search-block-desk .searchbox");
    var isOpen = false;
    submitIcon.click(function () {
      if (isOpen == false) {
        searchBox.addClass("searchbox-open");
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass("searchbox-open");
        inputBox.focusout();
        isOpen = false;
      }
    });
    submitIcon.mouseup(function () {
      return false;
    });
    searchBox.mouseup(function () {
      return false;
    });
    $(document).mouseup(function () {
      if (isOpen == true) {
        $(".search-block-desk .searchbox-icon").css("display", "block");
        submitIcon.click();
      }
    });
  },
  searchExpand: function () {
    function buttonUp() {
      var inputVal = $(".search-block-mov .searchbox-input").val();
      inputVal = $.trim(inputVal).length;
      if (inputVal !== 0) {
        $(".search-block-mov .searchbox-icon").css("display", "none");
      } else {
        $(".search-block-mov .searchbox-input").val("");
        $(".search-block-mov .searchbox-icon").css("display", "block");
      }
    }
    var submitIcon = $(".search-block-mov .searchbox-icon");
    var inputBox = $(".search-block-mov .searchbox-input");
    var searchBox = $(".search-block-mov .searchbox");
    var isOpen = false;
    submitIcon.click(function () {
      if (isOpen == false) {
        searchBox.addClass("searchbox-open");
        $("body").addClass("open-search");
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass("searchbox-open");
        $("body").removeClass("open-search");
        inputBox.focusout();
        isOpen = false;
      }
    });
    submitIcon.mouseup(function () {
      return false;
    });
    searchBox.mouseup(function () {
      return false;
    });
    $(document).mouseup(function () {
      if (isOpen == true) {
        $(".search-block-mov .searchbox-icon").css("display", "block");
        submitIcon.click();
      }
    });
    $(".search-block-mov .close-search").click(function () {
      if (isOpen == true) {
        $(".search-block-mov .searchbox-icon").css("display", "block");
        submitIcon.click();
      }
    });
  },
  countDown: function () {
    if ($(".listTiempo").length) {
      $("[data-countdown]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdown");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            )
          );
        });
      });
    }
  },
  countDownNav: function () {
    if ($(".listTiempoNav").length) {
      $("[data-countdownnav]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdownnav");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span></div>'
            )
          );
        });
      });
    }
  },
  countDownNavNoti: function () {
    if ($(".listTiempoNavNoti").length) {
      $("[data-countdownnavnoti]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdownnavnoti");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            )
          );
        });
      });
    }
  },
  countDownText: function () {
    if ($(".listTiempoText").length) {
      $("[data-countdowntext]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdowntext");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%Dd</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%Hh</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%Mm</span></div><span>:</span>' +
                '<div><span class="datos-tiempo">%Ss</span></div>'
            )
          );
        });
      });
    }
  },
  dropdownHover: function () {
    $(".dropdown-nav").hover(
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeIn("fast");
        $(this).addClass("open");
      },
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeOut("fast");
        $(this).removeClass("open");
      }
    );

    $(".custom-list-nav .dropdown").hover(
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeIn("fast");
        $(this).addClass("open");
      },
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeOut("fast");
        $(this).removeClass("open");
      }
    );

    $(".dropdown-learn").hover(
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeIn("fast");
        $(this).addClass("open");
      },
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeOut("fast");
        $(this).removeClass("open");
      }
    );

    $(".dropdown-user").hover(
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeIn("fast");
        $(this).addClass("open");
      },
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeOut("fast");
        $(this).removeClass("open");
      }
    );

    $(".dropdown-menu>li").hover(
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeIn("fast");
        $(this).addClass("open-sub");
      },
      function () {
        $(">.dropdown-menu", this).stop(true, true).fadeOut("fast");
        $(this).removeClass("open-sub");
      }
    );
  },
  mapMarket: function () {
    if ($(".map-canvas").length) {
      $(".mapShow").click(function (e) {
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($(".map-canvas")[0], {
          zoom: 16,
          center: new google.maps.LatLng(lat, log),
        });
        var marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(lat, log),
        });
        var info = new SnazzyInfoWindow({
          marker: marker,
          closeOnMapClick: false,
          content: direc,
        });
        info.open();
      });
    }
  },
  sidebarStickitCustom: function () {
    if ($(".sidebar-pay-block").length) {
      $(".sidebar-pay-block").stickit({
        screenMinWidth: 992,
        top: 30,
        onStick: function () {
          $("body").addClass("active-sidebar-index");
        },
        onUnstick: function () {
          $("body").removeClass("active-sidebar-index");
        },
        onEnd: function () {
          console.log("onEnd");
          $("body").addClass("active-s-fixed");
        },
        onUnend: function () {
          console.log("onUnend");
          $("body").removeClass("active-s-fixed");
        },
      });
    }
  },
  titleStiky: function () {
    if ($(".fixed-title").length) {
      $(".fixed-title").stickit({
        screenMinWidth: 992,
        top: 0,
        onStick: function () {
          $("body").addClass("active-z-index");
        },
        onUnstick: function () {
          $("body").removeClass("active-z-index");
        },
      });
    }
  },
  toggleUserCourse: function (e) {
    if ($(".info-text-autor").hasClass("toggle-active")) {
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    } else {
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  quantityNum: function () {
    if ($(".quantity").length) {
      $(".add-l").click(function () {
        var dataMax = $(this).data("max");
        if ($(this).prev().val() < dataMax) {
          $(this)
            .prev()
            .val(+$(this).prev().val() + 1);
        }
      });
      $(".sub-l").click(function () {
        if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1)
            $(this)
              .next()
              .val(+$(this).next().val() - 1);
        }
      });
    }
  },
  sliderGallery: function () {
    if ($(".inner-gallery-event").length) {
      $(".popup-gallery-lead").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Cargando imagen #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: "",
          titleSrc: function (item) {
            return item.el.attr("title");
          },
        },
      });
    }
  },
  hourReserv: function () {
    if ($(".block-calendar-reserv").length) {
      $("#datepickerMent").datepicker({
        language: "es",
        startDate: new Date(),
        format: "yyyy-mm-dd",
        datesDisabled: ["2020/08/06", "2020/08/21"],
        beforeShowDay: function (date) {
          return { content: "<button>" + date.getDate() + "</button>" };
        },
      });

      if ($(".footer-calendar-m").length) {
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function () {
        var eventR = $(this);
        var parentUl = $(".item-hour-resv");

        parentUl.find("ul li .resv-btn").hide();
        parentUl.find("ul li .event-resv").show();

        eventR.hide();
        eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  socialTeacher: function () {
    $(".up-social").click(function () {
      if ($(this).parent(".downActive").length) {
        $(this).parent(".social-teacher").removeClass("downActive");
      } else {
        $(this).parent(".social-teacher").addClass("downActive");
      }
    });
  },
  icoWhats: function () {
    if ($("#block-whats").length) {
      var navigationContainer = $("#block-whats"),
        mainNavigation = navigationContainer.find(
          "#cd-main-whats .block-nav-m"
        );
      $(".cd-whats-trigger").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
          )
          .toggleClass("is-visible");
      });
    }
  },
  sliderCour: function () {
    if ($(".block-slider-desktop").length) {
      $(".block-slider-desktop").each(function (i) {
        var bloqueSlider = $(this).data("bloque");
        var bloqueAutoPlay = $(this).data("play");
        var arrowSlider = $(this).data("arrow");

        if ($("." + bloqueSlider).length) {
          sliderRender(bloqueSlider, bloqueAutoPlay, arrowSlider);
        }
      });
      function sliderRender(bloque, modePlay, tArrow) {
        var slider = tns({
          container: "." + bloque,
          items: 1,
          loop: true,
          swipeAngle: false,
          speed: 400,
          nav: false,
          autoplay: modePlay,
          autoplayHoverPause: true,
          autoplayTimeout: 3000,
          autoplayButtonOutput: false,
          controlsContainer: "#" + tArrow,
          responsive: {
            0: {
              items: 1,
              //fixedWidth: 300
            },
            768: {
              items: 2,
              //fixedWidth: false
            },
            992: {
              items: 3,
            },
            1200: {
              items: 4,
            },
          },
        });
      }
    }
  },
  sliderCourCat: function () {
    if ($(".block-slider-category").length) {
      $(".block-slider-category").each(function (i) {
        var bloqueSlider = $(this).data("bloque");
        var bloqueAutoPlay = $(this).data("play");
        var arrowSlider = $(this).data("arrow");

        if ($("." + bloqueSlider).length) {
          sliderRender(bloqueSlider, bloqueAutoPlay, arrowSlider);
        }
      });
      function sliderRender(bloque, modePlay, tArrow) {
        var slider = tns({
          container: "." + bloque,
          items: 1,
          loop: true,
          swipeAngle: false,
          speed: 400,
          nav: false,
          autoplay: modePlay,
          autoplayHoverPause: true,
          autoplayTimeout: 3000,
          autoplayButtonOutput: false,
          controlsContainer: "#" + tArrow,
          responsive: {
            0: {
              items: 1,
              //fixedWidth: 300
            },
            768: {
              items: 2,
              //fixedWidth: false
            },
            992: {
              items: 3,
            },
            1200: {
              items: 4,
            },
          },
        });
      }
    }
  },
  sliderCourResp: function () {
    if ($(".block-slider-movil").length) {
      $(".item-slider-b").each(function (i) {
        var bloqueSlider = $(this).data("bloque");
        sliderRender(bloqueSlider);
      });
      function sliderRender(bloque) {
        var slider = tns({
          container: "." + bloque,
          items: 1,
          loop: false,
          swipeAngle: false,
          speed: 400,
          nav: false,
          //controls: false,
          responsive: {
            0: {
              items: 1,
              //fixedWidth: 300
            },
            768: {
              items: 2,
              //fixedWidth: 300
            },
          },
        });
      }
    }
  },
  sliderLearn: function () {
    if ($(".s-items-learn").length) {
      $(".s-items-learn").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $(".prev-learn"),
        nextArrow: $(".next-learn"),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
            },
          },
        ],
      });
    }
  },
  sliderCommunity: function () {
    if ($(".s-items-comm").length) {
      $(".s-items-comm").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(".prev-comm"),
        nextArrow: $(".next-comm"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  sliderSoftH: function () {
    if ($(".b-slider-soft-h").length) {
      $(".slider-soft-h").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 8,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 2000,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 8,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 6,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });

      $(".slider-soft-h-1").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 8,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 2000,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 8,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 6,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  },
  sliderStudent: function () {
    if ($(".b-slider-student-h").length) {
      $(".slider-student-h").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 9000,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $(".slider-student-h-two").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        pauseOnHover: true,
        rtl: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $(".slider-student-h-three").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 9000,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $(".slider-student-h-four").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        pauseOnHover: true,
        rtl: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $(".slider-student-h-five").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 9000,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }
  },
  sliderEvent: function () {
    if ($(".s-items-event").length) {
      var slider = tns({
        container: ".s-items-event",
        items: 1,
        loop: false,
        swipeAngle: false,
        speed: 400,
        nav: false,
        controlsContainer: "#s-items-event-arrows",
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 2,
          },
          1200: {
            items: 3,
          },
        },
      });
    }
  },
  textBox: function () {
    var setActive = function setActive(el, active) {
      var formField = el.parentNode.parentNode;

      if (active) {
        formField.classList.add("form-field--is-active");
      } else {
        formField.classList.remove("form-field--is-active");
        el.value === ""
          ? formField.classList.remove("form-field--is-filled")
          : formField.classList.add("form-field--is-filled");
      }
    };

    [].forEach.call(
      document.querySelectorAll(".form-field__input, .form-field__textarea"),
      function (el) {
        el.onblur = function () {
          setActive(el, false);
        };

        el.onfocus = function () {
          setActive(el, true);
        };
      }
    );
  },
  sliderCategory: function () {
    if ($(".s-items-cat").length) {
      $(".s-items-cat").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $(".prev-cat"),
        nextArrow: $(".next-cat"),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              infinite: true,
              centerPadding: "90px",
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              infinite: true,
              centerPadding: "60px",
            },
          },
        ],
      });
    }
  },
  scrollFilter: function () {
    if ($(".scrollbar-inner").length) {
      $(".scrollbar-inner").scrollbar();
    }
  },
  toggleFilter: function () {
    if ($(".inner-filter-result").length) {
      function myFunction(x) {
        if (x.matches) {
          $(".inner-filter-result").removeClass("active-filter");
        } else {
          $("body").removeClass("sidebar-movil-active");
        }
      }

      var x = window.matchMedia("(max-width: 992px)");
      myFunction(x);
      x.addListener(myFunction);

      function handler1() {
        $(".inner-filter-result").addClass("active-filter");
        $(this).one("click", handler2);
      }
      function handler2() {
        $(".inner-filter-result").removeClass("active-filter");
        $(this).one("click", handler1);
      }
      $(".btn-filter").one("click", handler1);

      /*event click Sidebar filter Movil*/
      $(".btn-filter-m").click(function () {
        $("body").addClass("sidebar-movil-active");
      });
      $(".close-sidebar-active").click(function () {
        $("body").removeClass("sidebar-movil-active");
      });
    }
  },
  isMobile: function () {
    var isMobile = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      isMobile = true;
    }
    return isMobile;
  },
  saveOrDoFilter: function (newHref) {
    if (custom.isMobile()) {
      localStorage.setItem("filterHref", newHref);
    } else {
      location.href = newHref;
    }
  },
  countEnabledFilters: function () {
    var countEnabledFilter = 0;
    $('.sidebar-filter .all-form-filter input[type="checkbox"]').each(function (
      e
    ) {
      if ($(this).attr("checked")) {
        countEnabledFilter++;
      }
    });

    var countEnabledFilterText = "";
    if (countEnabledFilter > 0) {
      countEnabledFilterText = "(" + countEnabledFilter + ")";
    }

    $(".count-filter").text(countEnabledFilterText);
  },
  filterHandle: function () {
    var urlParams = new URLSearchParams(window.location.search);
    var splitHref = window.location.href.split("?");

    $('.sidebar-filter .all-form-filter input[type="checkbox"]').click(
      function (e) {
        var key = e.target.value.split("_")[0] + "[]";
        var value = e.target.value.split("_")[1];
        if (e.target.checked) {
          if (urlParams.has(key)) {
            if (urlParams.getAll(key).indexOf(value) < 0) {
              urlParams.append(key, value);
            }
          } else {
            urlParams.append(key, value);
          }
        } else {
          if (urlParams.has(key)) {
            var values = urlParams.getAll(key);
            if (values.indexOf(value) > -1) {
              values.splice(values.indexOf(value), 1);
              urlParams.delete(key);

              values.forEach(function (value1) {
                urlParams.append(key, value1);
              });
            }
          }
        }

        var newHref = splitHref[0] + "?" + urlParams.toString();
        custom.saveOrDoFilter(newHref);
      }
    );

    $("#order-select").change(function (e) {
      urlParams.set("order", e.target.value);

      var newHref = splitHref[0] + "?" + urlParams.toString();
      location.href = newHref;
    });

    $("button.btn-clean").click(function (e) {
      var newUrlParams = new URLSearchParams("");
      if (urlParams.has("page")) {
        newUrlParams.set("page", urlParams.get("page"));
      }

      var newHref = splitHref[0] + "?" + newUrlParams.toString();
      location.href = newHref;
    });

    $("#apply-filter").click(function (e) {
      var lsHref = localStorage.getItem("filterHref");
      location.href = lsHref;
    });
  },
  blogNewsletter: function () {
    $("#form-suscribete-blog").validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: "Por favor ingresa tu Email",
        },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $("#form-suscribete-blog").serialize();
        $.ajax({
          url: "/es/page/newsletter",
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {},
          success: function (data) {
            $("#section-suscribete-blog").hide();
            if (data.success) {
              $("#section-suscribete-blog-success").show();
            } else {
              $("#section-suscribete-blog-success").html(
                "<p>No se completó tu registro</p>"
              );
            }
          },
        });
        return false;
      },
    });
    return false;
  },
  footerNewsletter: function () {
    $("#form-suscribete-footer").validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: "Por favor ingresa tu Email",
        },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $("#form-suscribete-footer").serialize();
        $.ajax({
          url: "/es/page/newsletter",
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {},
          success: function (data) {
            $("#section-suscribete-footer").hide();
            if (data.success) {
              $("#section-suscribete-footer-success").show();
            } else {
              $("#section-suscribete-footer-success").html(
                "<p>No se completó tu registro</p>"
              );
            }
          },
        });
        return false;
      },
    });
    return false;
  },
  partnerRegister: function () {
    $("#partner-form-register").validate({
      // Specify the validation rules
      rules: {
        name: { required: true },
        lastName: { required: true },
        email: { required: true },
        password: { required: true },
      },
      messages: {
        name: { required: "Por favor ingrese su Nombre" },
        lastName: { required: "Por favor ingrese su Apellido" },
        email: { required: "Por favor ingrese su Email" },
        password: { required: "Por favor ingrese su Password" },
      },
      errorPlacement: function (error, element) {
        // error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
      },
      submitHandler: function (form) {
        $("#partner-form-register")
          .find(".btn-l-primary")
          .addClass("block-btn-load");
        var params = $("#partner-form-register").serialize();
        params = params + "&" + "isMarketChild=1";
        $.ajax({
          url: main.getUri("/api-reseller/partner"),
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {
            xhr.overrideMimeType("text/plain; charset=x-user-defined");
            xhr.setRequestHeader("Authorization", main.resellerToken);
          },
          success: function (data) {
            $("#register-form-register")
              .find(".btn-l-primary")
              .removeClass("block-btn-load");
            if (data.success == true) {
              $("#partner-form-register").trigger("reset");
              $("#idPartnerRegisterMessage").html(
                "El partner fue creado correctamente"
              );
            } else {
              $("#idPartnerRegisterMessage").html("Error en el proceso");
            }
          },
        });
        return false;
      },
    });
  },
  activeBtnTab: function () {
    if ($(".btn-tab").length) {
      $(".btn-tab").click(function () {
        $(".btn-tab").removeClass("active");
        $(this).addClass("active");
      });
    }
  },
  filterFixed: function () {
    if ($(".filter-fixed").length) {
      $(".filter-fixed").stickit();
    }
  },
  addCalendar: function () {
    $(".addEventCalendar").addToCalendar({
      filename: "mi-calendario", // filename download for ical excluding extension
      target: "_blank", // specifies the target attribute of the window
      providers: {
        google: "Google Calendar", // provider name and label
        outlook: "Outlook Calendar", // provider name and label
        yahoo: "Yahoo! Calendar", // provider name and label
        other: "Other Calendar", // other property force download event as .ics for ical
      },
      onAddEvent: function () {}, // callback after click provider link
    });
  },
  categorySlider: function () {
    if ($(".cat-slider-f").length) {
      $(".cat-slider-f").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        appendDots: $(".b-arrow-cs"),
        prevArrow: $(".prev-ct-home"),
        nextArrow: $(".next-ct-home"),
      });
    }
  },
  catFilter: function () {
    if ($(".b-slider-cat").length) {
      $(".cat-filter").slick({
        slidesToShow: 1,
        variableWidth: true,
        prevArrow: $(".t-prev-cat"),
        nextArrow: $(".t-next-cat"),
        infinite: true,
        focusOnSelect: true,
      });

      custom.loadSlidePublications("");

      $(".inner-cat-filter").on("click", function () {
        var categoryId = $(this).data("category");
        custom.loadSlidePublications(categoryId);

        $(".inner-cat-filter").removeClass("active-cat");
        $(this).addClass("active-cat");
      });
    }
  },
  companyInstitution: function () {
    if ($(".b-company-institution").length) {
      $(".slider-company-institution").slick({
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $(".t-prev-inst"),
        nextArrow: $(".t-next-inst"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  officialTraining: function () {
    if ($(".b-offi-trai").length) {
      $(".slider-offi-trai").slick({
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $(".t-prev-trai"),
        nextArrow: $(".t-next-trai"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  certificatedExpert: function () {
    if ($(".teacher-certified-expert").length) {
      $(".teacher-certified-expert").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $(".t-prev-cert"),
        nextArrow: $(".t-next-cert"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  certSlider: function () {
    if ($(".cert-slider-item").length) {
      $(".cert-slider-item").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        autoplaySpeed: 2500,
        cssEase: "linear",
        appendDots: $(".b-arrow-cer"),
        prevArrow: $(".prev-sc-home"),
        nextArrow: $(".next-sc-home"),
      });
    }
  },
  certSliderOpc: function () {
    if ($(".cert-slider-opc").length) {
      $(".cert-slider-opc").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        autoplaySpeed: 2500,
        cssEase: "linear",
        appendDots: $(".b-arrow-cer-opc"),
        prevArrow: $(".prev-sc-opc"),
        nextArrow: $(".next-sc-opc"),
      });
    }
  },
  teacherExpert: function () {
    if ($(".teacher-expert").length) {
      $(".teacher-expert").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow: $(".t-prev"),
        nextArrow: $(".t-next"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  videoIframeEvent: function () {
    $(".eventVideoFrame").click(function () {
      var linkSrc = $(this).data("video");
      $("#contVideoTest").find("iframe").attr("src", linkSrc);
    });

    $("#videoStudentModal").on("hidden.bs.modal", function (event) {
      $("#contVideoTest").find("iframe").attr("src", "");
    });
  },
  sliderCourse: function () {
    if ($(".slider-item-c").length) {
      $(".slider-item-c").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        appendDots: $(".b-arrow-ds"),
        prevArrow: $(".prev-ds-home"),
        nextArrow: $(".next-ds-home"),
      });
    }
  },
  sliderCourseEsp: function () {
    if ($(".s-slide-s").length) {
      var slideEspc = $(".s-slide-s");
      var currentSlide;
      var slidesCount;
      slideEspc
        .on("init", function (event, slick, direction) {
          var i = (currentSlide ? currentSlide : 0) + 1;
          $("#numCurrent").text(i);
          $("#numTotal").text(slick.slideCount);
          switch (slick.slideCount) {
            case 3:
              $(".arrow-esp").addClass("arrow-3");
              break;
            case 2:
              $(".arrow-esp").addClass("arrow-2");
              break;
            case 1:
              $(".arrow-esp").addClass("arrow-1");
              break;
            default:
              console.log("No hay item");
          }
        })
        .slick({
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          prevArrow: $(".t-prev-s"),
          nextArrow: $(".t-next-s"),
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });

      slideEspc.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          var i = (currentSlide ? currentSlide : 0) + 1;
          $("#numCurrent").text(i);
          $("#numTotal").text(slick.slideCount);
        }
      );
    }
  },
  sliderProduct: function () {
    if ($(".block-product-h").length) {
      var slider = tns({
        container: ".s-items-product",
        items: 1,
        loop: true,
        swipeAngle: false,
        speed: 400,
        nav: false,
        autoplay: false,
        autoplayHoverPause: true,
        autoplayTimeout: 3000,
        autoplayButtonOutput: false,
        controlsContainer: "#s-items-product-arrows",
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
          1200: {
            items: 4,
          },
        },
      });
    }
  },
  videoIframe: function () {
    $(".item-video").click(function () {
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = $(this).data("video");
      $("#videoModal").modal("show");
      $("#course-video-content").html(htmlVideo);
      setTimeout(function () {
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $("#videoModal").on("hidden.bs.modal", function (event) {
      $("#course-video-content").find("iframe").attr("src", "");
    });
  },
  fileAdd: function () {
    $("#uploadArchive").on("change", function () {
      files = $(this)[0].files;
      name = "";
      for (var i = 0; i < files.length; i++) {
        name += '"' + files[i].name + '"' + (i != files.length - 1 ? ", " : "");
      }
      $(".custom-file-label-u").html(name);
    });
  },
  formContactCustomized: function () {
    $("#formContact").validate({
      rules: {
        name: "required",
        lastname: "required",
        email: { required: true, email: true },
        phone: "required",
        message: "required",
        profession: "required",
      },
      messages: {
        name: "Ingrese su nombre",
        lastname: "Ingrese su apellido",
        email: "Ingresa una direccion de correo electrónico",
        phone: "Ingrese su número de telefóno",
        message: "Ingrese su mensaje",
        profession: "Profesion",
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $("#formContact").serialize();
        $.ajax({
          url: "/es/page/send-contact",
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {},
          success: function (data) {
            if (data.success) {
              $("#formContact").html(
                '<div class="clear-fix message-result"><span><em><i class="fas fa-check"></i></em> Mensaje enviado exitosamente</span></div>'
              );
            } else {
              $("#formContact").html(
                "<p>Error de conexión intentelo en unos minutos</p>"
              );
            }
          },
        });
        return false;
      },
    });
    return false;
  },
  payFixed: function () {
    if ($("#block-fixed-pay").length) {
      var navigationContainer = $("#block-fixed-pay"),
        mainNavigation = navigationContainer.find("#b-inner-pay .block-pay-m");
      $(".pay-btn-trigger").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        $("body").toggleClass("payModal");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
          )
          .toggleClass("is-visible");
      });
      /*Cerrar en Ancla*/
      $(".pay-fixed .pay-btn-close").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        $("body").toggleClass("payModal");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
          )
          .toggleClass("is-visible");
      });
    }
  },
  moreBlockAll: function () {
    $(".all-t-more .moreActive").on("click", function () {
      $(this).parent().find(".b-p").toggleClass("hide-desc");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
    });

    $(".t-more-n .moreActive").on("click", function () {
      $(this).parent().find(".b-p1").toggleClass("t-active");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).hasClass("t-active")) {
        $(this).html('Ocultar resumen <i class="fas fa-chevron-right"></i>');
      } else {
        $(this).html('Ver resumen <i class="fas fa-chevron-right"></i>');
      }
    });
  },
  moreBlock: function () {
    $(".link-moore").on("click", function () {
      $(".b-teaser").toggleClass("b-display");
      $(".b-complete").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
      var heightBloque =
        document.getElementById("all-desc-course").offsetHeight + 144;
      document
        .getElementById("bg-header-course")
        .setAttribute("style", "height: " + heightBloque + "px");
    });
  },
  moreDesc: function () {
    $(".link-todo").on("click", function () {
      $(".b-one").toggleClass("b-ocultar");
      $(".b-two").slideToggle(0);
      if ($(this).find("span").text() == "Ver todo") {
        $(this).find("span").text("Ver menos");
        $(this).addClass("show-ico");
      } else {
        $(this).find("span").text("Ver todo");
        $(this).removeClass("show-ico");
      }
    });
  },
  moreComment: function () {
    console.log("moreComment");
    var contentComment = $("#allComment");
    var loadingComment = '<div class="loading-comment"><span></span></div>';
    $(".link-comment").on("click", function () {
      var pageCount = $(this).data("page-count");
      var paginated = $(this).data("paginated"); //Obteniendo el paginado inicial
      var publicationId = $(this).data("publication");
      console.log("page: " + paginated + " | publicationId: " + publicationId);
      contentComment.prepend(loadingComment); //Agregando loading
      $.ajax({
        url: "/service/comments-publication/" + publicationId,
        data: { page: paginated },
        type: "GET",
        dataType: "json",
        beforeSend: function (xhr) {},
        success: function (data) {
          if (data.success) {
            console.log({
              pageCount: parseInt(pageCount),
              current: data.page.current,
              next: data.page.next,
            });
            if (data.page.current == parseInt(pageCount)) {
              // ver comentarios disabled - limit
              $(".link-comment").removeClass("link-locked"); //Eliminar el bloqueo
            }
            $(".loading-comment").remove(); //Eliminando loading
            contentComment.addClass("display-comment"); //Para eliminar el degradado
            $(".link-comment").data("paginated", data.page.next); //para agregar el paginado, 2,3,4, etc
            htmlComments = "";
            $.each(data.data, function (index, value) {
              htmlAverage = "";
              for (var i = 1; i <= value.average; i++) {
                htmlAverage += '<i class="fas fa-star"></i>';
              }
              if (value.average < 5) {
                for (var i = value.average; i <= 5; i++) {
                  htmlAverage +=
                    '<i class="far fa-star color-disable-star"></i>';
                }
              }

              stringComment = "";
              if (value.comment && value.comment != "null") {
                stringComment = value.comment;
              }

              flag = "";
              if (value.countryCode) {
                flag =
                  data.baseCountry +
                  "assets/images/country/" +
                  value.countryCode +
                  ".svg";
                stringFlag =
                  '<span style="background: url(' +
                  flag +
                  ') no-repeat;background-size: cover;background-position: center;"></span>';
              }

              htmlComments +=
                '<div class="clear-fix list-answer">' +
                '<div class="row">' +
                '<div class="col-md-4">' +
                '<div class="clear-fix b-figure-ans">' +
                "<figure>" +
                '<i style="background: url(' +
                value.image.thumbnai +
                ') no-repeat;background-size: cover;background-position: center;"></i>' +
                stringFlag +
                "</figure>" +
                "<h4>" +
                value.user +
                "</h4>" +
                '<div class="start-calf">' +
                htmlAverage +
                "</div>" +
                "</div>" +
                "</div>" +
                '<div class="col-md-8">' +
                '<div class="clear-fix inf-ans-t">' +
                "<p>" +
                stringComment +
                "</p>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "</div>";
            });
            $("#allComment").append(htmlComments);
          }
        },
      });
    });
  },
  categoryModal: function () {
    $("#id-mNetzun").on("click", function () {
      console.log("mNetzun");
      $.ajax({
        url: "/page/external-category-list",
        data: {},
        type: "GET",
        dataType: "json",
        beforeSend: function (xhr) {
          $("#list-categories-netzun").html(
            '<div class="mx-3" style="color: white"><span>Cargando...</span></div>'
          );
        },
        success: function (data) {
          if (data.success) {
            $("#list-categories-netzun").html(data.html);
          }
        },
      });
    });

    $("#id-mKonstruedu").on("click", function () {
      console.log("mKonstruedu");
      $.ajax({
        url: "/page/category-list",
        data: {},
        type: "GET",
        dataType: "json",
        beforeSend: function (xhr) {
          $("#list-categories").html(
            '<div class="mx-3" style="color: white"><span>Cargando...</span></div>'
          );
        },
        success: function (data) {
          if (data.success) {
            $("#list-categories").html(data.html);
          }
        },
      });
    });
  },
  registerBusiness: function (countryCode) {
    // var intPhoneNumber = event.validationInputPhoneCode('inputPhoneNumber', countryCode);
    if ($("#inputPhoneNumberReg").length) {
      var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberReg");
      var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
    $("#formBusinessRegister").validate({
      rules: {
        name: { required: true },
        email: {
          required: true,
          email: true,
        },
        business: { required: true },
        inputPhoneNumberReg: { required: true },
        collaborators: { required: true },
      },
      messages: {
        name: { required: "Ingrese su Nombre." },
        email: { required: "Ingrese su E-mail." },
        business: { required: "Ingrese el nombre de la empresa." },
        inputPhoneNumberReg: { required: "Ingrese su número telefónico." },
        collaborators: { required: "Ingrese un número." },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        $("#btnSubmit").attr("disabled", true);
        var textButtom = $("#btnSubmit").text();
        $("#btnSubmit").text("Enviando..");
        var params = $(form).serialize();
        params +=
          "&phoneCode=" + intPhoneNumberReg.getSelectedCountryData().dialCode;
        $.ajax({
          url: "/es/service/business-register",
          data: params,
          type: "POST",
          dataType: "json",
          success: function (data) {
            if (data.success) {
              $("#businessContentForm").html(
                '<div class="clear-fix form-premium-enterprise"><div class="clear-fix b-body-form"><i class="fas fa-check-circle"></i><h4>¡Felicitaciones, ya estas registrado!</h4><p>En breve te contactaremos para empezar la capacitación de tu equipo.</p></div><div class="clear-fix b-footer-form"><a href="/cursos" class="btn-l-view-c">Ver cursos</a></div></div>'
              );
            } else {
              document.getElementById("security").value = data.security;
              swal({
                title: "Se produjo un error",
                //text: data.message,
                type: "error",
                confirmButtonColor: "#039BE5",
                html: data.message,
                confirmButtonText: "Ingresar",
                onClose: openLogin,
              });
            }
            $("#btnSubmit").attr("disabled", false);
            $("#btnSubmit").text(textButtom);
          },
        });
      },
    });
    return false;
  },
  loadSlidePublications: function (categoryId) {
    $.ajax({
      url: "/es/home/slide-publication",
      data: "categoryId=" + categoryId,
      type: "POST",
      dataType: "json",
      beforeSend: function (xhr) {
        // colocar html de loading
        var htmlRender =
          '<div class="clear-fix all-loading-cat">' +
          '<div class="row">' +
          '<div class="col-md-6 col-lg-4 col-xl-3">' +
          '<div class="item-loading-cat">' +
          "<figure></figure>" +
          '<div class="clear-fix inf-loading">' +
          '<span class="s-1"></span>' +
          '<span class="s-2"></span>' +
          '<span class="s-3"></span>' +
          '<span class="s-4"></span>' +
          "</div>" +
          '<div class="clear-fix footer-loading">' +
          "<span></span>" +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="col-md-6 col-lg-4 col-xl-3">' +
          '<div class="item-loading-cat">' +
          "<figure></figure>" +
          '<div class="clear-fix inf-loading">' +
          '<span class="s-1"></span>' +
          '<span class="s-2"></span>' +
          '<span class="s-3"></span>' +
          '<span class="s-4"></span>' +
          "</div>" +
          '<div class="clear-fix footer-loading">' +
          "<span></span>" +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="col-md-6 col-lg-4 col-xl-3">' +
          '<div class="item-loading-cat">' +
          "<figure></figure>" +
          '<div class="clear-fix inf-loading">' +
          '<span class="s-1"></span>' +
          '<span class="s-2"></span>' +
          '<span class="s-3"></span>' +
          '<span class="s-4"></span>' +
          "</div>" +
          '<div class="clear-fix footer-loading">' +
          "<span></span>" +
          "</div>" +
          "</div>" +
          "</div>" +
          '<div class="col-md-6 col-lg-4 col-xl-3">' +
          '<div class="item-loading-cat">' +
          "<figure></figure>" +
          '<div class="clear-fix inf-loading">' +
          '<span class="s-1"></span>' +
          '<span class="s-2"></span>' +
          '<span class="s-3"></span>' +
          '<span class="s-4"></span>' +
          "</div>" +
          '<div class="clear-fix footer-loading">' +
          "<span></span>" +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>";
        $("#slidePublicationId").html(htmlRender);
      },
      success: function (response) {
        if (response.success) {
          $("#slidePublicationId").html(response.data.html);
        } else {
          $("#slidePublicationId").html("<p>No se encontraron cursos</p>");
        }
      },
    });
  },
  anclaBlockKons: function () {
    $(".blockAnclaKons").click(function (e) {
      e.preventDefault();
      var strAncla = $(this).attr("href");
      $("body,html")
        .stop(true, true)
        .animate(
          {
            scrollTop: $(strAncla).offset().top - 60,
          },
          1000
        );
    });
  },
  validarFormAddInterested: function (dataCountry, formId, phoneId, successId) {
    var tagFormId = "#" + formId;
    var tagPhoneId = "#" + phoneId;
    var tagSuccessId = "#" + successId;
    if ($(tagFormId).length) {
      if (!dataCountry) {
        dataCountry = "co";
      }
      var inputPhoneNumberReg = document.querySelector(tagPhoneId);
      var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
        initialCountry: dataCountry,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
    $(tagFormId).validate({
      rules: {
        inputFullName: { required: true },
        inputPhoneNumber: { required: true },
        inputEmailAddress: {
          required: true,
          email: true,
        },
      },
      messages: {
        inputFullName: { required: "Ingrese su Nombre." },
        inputPhoneNumber: { required: "Ingrese un número." },
        inputEmailAddress: { required: "Ingrese su E-mail." },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $(tagFormId).serialize();
        params +=
          "&phoneCode=" + intPhoneNumberReg.getSelectedCountryData().dialCode;
        $.ajax({
          url: "/es/page/new-interested",
          data: params,
          type: "POST",
          dataType: "json",
          success: function (data) {
            if (data.success) {
              if (data.redirect) {
                location.href = data.redirectUri;
              } else {
                $(tagSuccessId).html("<p>" + data.message + "</p>");
                $(tagFormId).html("<p>" + data.message + "</p>");
              }
            } else {
              swal({
                title: "Se produjo un error",
                text: data.message,
                type: "error",
                confirmButtonColor: "#039BE5",
              });
            }
          },
        });
      },
    });
  },
  validationRegisterEventOnline: function (
    countryCode,
    publicationId,
    formId,
    phoneId,
    successId
  ) {
    var tagFormId = "#" + formId;
    var tagPhoneId = "#" + phoneId;
    var tagSuccessId = "#" + successId;
    var textButtom = $(tagFormId + " button").text();

    // var intPhoneNumber = event.validationInputPhoneCode('inputPhoneNumber', countryCode);
    if ($(tagPhoneId).length) {
      var inputPhoneNumberReg = document.querySelector(tagPhoneId);
      var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }

    $("#showRegisterFormId").click(function (e) {
      e.preventDefault();
      $("#messageSectionId").hide();
      $("#formSectionId").show();
      $(tagFormId + " button").attr("disabled", false);
      $(tagFormId + " button").text(textButtom);
    });

    $(tagFormId).validate({
      rules: {
        inputFullName: { required: true },
        inputEmailAddress: {
          required: true,
          email: true,
        },
        inputPassword: { required: true },
        inputPhoneNumber: { required: true },
      },
      messages: {
        inputFullName: { required: "Ingrese su Nombre." },
        inputEmailAddress: { required: "Ingrese su E-mail." },
        inputPassword: { required: "Ingrese su nueva contraseña" },
        inputPhoneNumber: { required: "Ingrese un número." },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        $(tagFormId + " button").attr("disabled", true);
        $(tagFormId + " button").text("Enviando..");
        var params = $(form).serialize();
        params +=
          "&phoneCode=" +
          intPhoneNumberReg.getSelectedCountryData().dialCode +
          "&publicationId=" +
          publicationId;
        $.ajax({
          url: "/es/page/new-interested",
          data: params,
          type: "POST",
          dataType: "json",
          success: function (data) {
            if (data.success) {
              if (data.redirect) {
                location.href = data.redirectUri;
              } else {
                $(tagSuccessId).html("<p>" + data.message + "</p>");
              }
            } else {
              document.getElementById("security").value = data.security;

              if (data.login) {
                $("#formSectionId").hide();
                $("#messageTextId").text(data.message);
                $("#messageSectionId").show();
              } else {
                swal({
                  title: "Se produjo un error",
                  //text: data.message,
                  type: "error",
                  confirmButtonColor: "#039BE5",
                  html: data.message,
                  confirmButtonText: "Ingresar",
                  onClose: openLogin,
                });

                $(tagFormId + " button").attr("disabled", false);
                $(tagFormId + " button").text(textButtom);

                function openLogin() {
                  $("#loginModal").modal("show");
                }
              }
            }
          },
        });
      },
    });

    return false;
  },
  scrollBarModal: function () {
    if ($(".scroll-bar-k").length) {
      $(".scroll-bar-k").scrollbar();
    }
  },
};
